import { request } from '@core/api/request';

export const uploadMedia = async (media: File) => {
  // eslint-disable-next-line no-useless-catch
  try {
    const formData = new FormData();
    formData.append('file', media); // Add the file as a binary
    formData.append('mime_type', media.type); // Optional, if needed by the endpoint

    const response = await request({
      url: `media/`,
      method: 'POST',
      body: formData,
    });

    return response;
  } catch (error: unknown) {
    throw error;
  }
};
